import { render } from "./Activity.vue?vue&type=template&id=40b1061d&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=40b1061d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b1061d"]])

export default __exports__